module.exports = __webpack_public_path__ + "static/media/mobile_archero2_page_area01_img_cn@2x.773f1705.png";